import React from "react";
import { connect } from "react-redux";
import { ActivityHistoryContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import moment from "moment";
import { RenderCommaMoney } from "utils/functions/formatMoney";
import { RENDER_SEAT_BOOKING_STATUS } from "utils/functions/seatBooking";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { MemberSwitchTypeWidget } from "widgets";
import { Buttons, Displays, Navigations, Tables } from "components";

class ActivityHistoryContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData(`?member_type=${this.props.authenRedux.member_type_active}`);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.authenRedux &&
      this.props.authenRedux !== prevProps.authenRedux
    ) {
      this.fetchData(
        `?member_type=${this.props.authenRedux.member_type_active}`,
      );
    }
  }

  fetchData = async (queryString) => {
    // การจองที่นั่ง (Booking Seat) เก็บแยกจาก activity_history รวมแสดงในหน้านี้ (สมาชิกบุคคลเท่านั้น)
    const isPersonal =
      this.props.authenRedux && this.props.authenRedux.member_type_active === "1";
    let [res, resSeat] = await Promise.all([
      userService.GET_MY_ACTIVITY(queryString),
      isPersonal ? userService.GET_MY_SEAT_BOOKING_HISTORY() : null,
    ]);
    if (res && res.status === 200) {
      const seatRows =
        resSeat && resSeat.status === 200
          ? resSeat.data.map((e) => ({
              ...e,
              is_seat_booking: true,
              created_at: e.submitted_at || e.created_at,
            }))
          : [];
      this.setState({
        data: seatRows.length
          ? [...res.data, ...seatRows].sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at),
            )
          : res.data,
        isLoading: false,
      });
    }
  };

  // แถวเดิมของ activity_history ไม่มีการกด (ไม่เคยมี handler) กดได้เฉพาะแถวจองที่นั่ง ไปดูตั๋วในหน้ากิจกรรม
  handleClickHistory = (e) => {
    if (e.is_seat_booking) {
      this.props.router.navigate(`${ROUTE_PATH.ACTIVITIES}/${e.activity_id}`);
    }
  };

  render() {
    const { i18n, router, t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("History", { ns: "common" }),
        path: ROUTE_PATH.HISTORY,
      },
      {
        name: t("Activity Registration History", { ns: "common" }),
      },
    ];
    return (
      <ActivityHistoryContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="activity_history_container">
          <div className="member_type_layout">
            <MemberSwitchTypeWidget type="4" />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="product_warranty_title">
                {i18n.language === "en"
                  ? "Activity Registration History"
                  : "ประวัติการลงทะเบียนกิจกรรม"}
              </div>
              <Tables.HeaderRowPanel
                columns={columns({ i18n })}
                data={data}
                onClickRow={this.handleClickHistory}
              />
            </>
          )}
          <div className="btn_wrap">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={() => router.navigate(-1)}
            />
          </div>
        </div>
      </ActivityHistoryContainerStyled>
    );
  }
}

const columns = ({ i18n }) => [
  {
    title: i18n.language === "en" ? "Date" : "วันที่",
    field: "created_at",
    headerStyle: { width: "184px", textAlign: "center" },
    style: { width: 184, textAlign: "center" },
    render: ({ value }) => moment(value).format("DD-MM-YYYY"),
  },
  {
    title: i18n.language === "en" ? "List" : "รายการ",
    field: "activity_name",
    headerStyle: { textAlign: "center" },
    render: ({ origin, value }) =>
      origin.is_seat_booking
        ? `${i18n.language === "en" ? origin.activity_name_en : origin.activity_name_th} (${origin.code})`
        : value,
  },
  {
    title: i18n.language === "en" ? "Point" : "คะแนน",
    field: "activity_point",
    headerStyle: { width: "184px", textAlign: "center" },
    style: { width: 184, textAlign: "center" },
    // แถวจองที่นั่งไม่มีแต้ม แสดงสถานะการจองแทน
    render: ({ origin, value }) =>
      origin.is_seat_booking
        ? i18n.t(RENDER_SEAT_BOOKING_STATUS(origin.status).labelKey, { ns: "seat" })
        : `${RenderCommaMoney(value)} Points`,
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common", "profile"])(withRouter(ActivityHistoryContainer)));
